import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';

@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss']
})
export class TaskComponent implements OnInit {

  permissionAsssign: any[] = [];
  folderListPermission : any[] = [];
  folderList: any[] = [];
  
  constructor(private router: Router,
    private _dataSharingService: DataSharingService,
    private cdr: ChangeDetectorRef) {
    
   }

   ngAfterContentChecked(){
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
   // this.permissionAsssign = JSON.parse(sessionStorage.getItem("permissions")); 

    // this.permissionAsssign =this.permissionAsssign.filter((x) => x.permissionName.toLowerCase() == 'menu task');

    // if(this.permissionAsssign.length == 0){
    //   this.router.navigate(['unauthorised']);
    //   return;
    // }
    //this.folderListPermission = this.folderList.filter(o1 => this.permissionAsssign.some(o2 => o1.folderName.toLowerCase() === o2.moduleRoute.toLowerCase()));
   
    // if(this.folderListPermission.length > 0){
    //   var module = this.folderListPermission.filter(x => x.folderName.toLowerCase() === "task");
    //   if(module.length == 0){
    //     this.router.navigate(['unauthorised']);
    //     return;
    //   }
    // }
  }

}
